export
const name: string = "FullscreenQuad";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3 a_position;
`;

export
const varyings: string = `
    varying   vec2 v_tex_coord;
`;

export
const implementation: string = `
    void main()
    {
       v_tex_coord = a_position.xy * vec2(0.5, 0.5) + vec2(0.5, 0.5); // scale vertex attribute to [0-1] range
       gl_Position = vec4(a_position.xy, 0.0, 1.0);
    }
`;
